/**
 * Pagina editor motivazione attività
 * @module Pages/Admin/Motivazioni/Editor
 */

import { useNavigate, useParams } from 'react-router-dom'
import { Button, Flex, Spinner, Text } from '../../../../Components'
import { saveMotivazione, useMotivazione } from '../Functions'
import { FloatInput } from '../../../Gigi/GigiForm/TransferField/InputForm'
import { useState } from 'react'
import { useCQuery } from '../../../../Services/QueryCache'

export function MotivazioneEditor () {
  const { motivazioneId } = useParams()
  const navigate = useNavigate()
  const [motivazione, setMotivazione, isSuccess] = useMotivazione(motivazioneId)
  const { data: sottoProcessi = [], isSuccess: isSuccessSottoProcessi } = useCQuery(['sottoProcessiAttivita'])
  const [checkError, setCheckError] = useState(false)

  const save = async () => {
    setCheckError(true)
    if (!motivazione?.codice || !motivazione?.label) {
      window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Compila i campi obbligatori' })
      return
    }
    const res = await saveMotivazione(motivazione)
    if (res) navigate('/admin/motivazioni/list')
  }

  const isNew = motivazioneId === 'new'

  if (!isSuccess || !motivazione || !isSuccessSottoProcessi) return <Spinner />

  // Costruisce le opzioni per il dropdown con il processo padre
  const sottoProcessiOptions = [
    { label: 'Nessun sotto-processo', value: null },
    ...sottoProcessi.map(sp => ({
      label: `${sp.descrizione || sp.codice}${sp.processiAttivitum ? ` (${sp.processiAttivitum.descrizione || sp.processiAttivitum.codice})` : ''}`,
      value: sp.id
    }))
  ]

  return (
    <Flex fw>
      <Text value={`${isNew ? 'Crea' : 'Modifica'} Motivazione`} title bold size={30} />
      <Flex fw row wrap style={{ marginTop: 20 }}>
        <Flex style={{ width: '24%', marginRight: '1%' }}>
          <FloatInput
            value={[motivazione.codice || '', (val) => setMotivazione('codice', val)]}
            error={checkError && !motivazione.codice}
            label='Codice' id='codice'
          />
        </Flex>
        <Flex style={{ width: '36%', marginRight: '1%', marginLeft: '1%' }}>
          <FloatInput
            value={[motivazione.label || '', (val) => setMotivazione('label', val)]}
            error={checkError && !motivazione.label}
            label='Label' id='label'
          />
        </Flex>
        <Flex style={{ width: '36%', marginLeft: '1%' }}>
          <FloatInput
            type='dropdown' filter
            value={[motivazione.sottoProcessoId, (val) => setMotivazione('sottoProcessoId', val)]}
            options={sottoProcessiOptions}
            label='Sotto-Processo' id='sottoProcessoId'
          />
        </Flex>
      </Flex>
      <Flex fw row style={{ marginTop: 30 }}>
        <Button label='Salva' icon='fa-duotone fa-check' style={{ marginRight: 10 }} onClick={save} />
        <Button label='Torna indietro' icon='fa-duotone fa-arrow-left' onClick={() => navigate('/admin/motivazioni/list')} />
      </Flex>
    </Flex>
  )
}
